import * as mutationTypes from 'store/mutationTypes'

/**
 * @return {Promise}
 */
export const setCurrentAttributionId = function ({ commit }, attributionId) {
  if (!attributionId) return Promise.reject('attributionId is required')

  return commit(mutationTypes.SET_CURRENT_ATTRIBUTION_ID, attributionId)
}



// WEBPACK FOOTER //
// ./src/store/modules/attributionId/actions.js